var map = {
	"./game-logo_AdvancedJackpotSystem.svg": "5ec5",
	"./game-logo_CrashCashAviator.svg": "87c6",
	"./game-logo_GreyhoundRaces.svg": "06fd",
	"./game-logo_HorseRaces.svg": "5d7b",
	"./game-logo_Keno.svg": "893b",
	"./game-logo_Lottery.svg": "5d4e",
	"./game-logo_LuckySix.svg": "022b",
	"./game-logo_LuckyX.svg": "ec6e",
	"./game-logo_NSoft.svg": "cd17",
	"./game-logo_NextSix.svg": "ba09",
	"./game-logo_Roulette.svg": "29b8",
	"./game-logo_SlotCarRaces.svg": "ddee",
	"./game-logo_SpinAndWin.svg": "45b7",
	"./game-logo_VirtualDragRaces.svg": "7915",
	"./game-logo_VirtualGreyhoundRaces.svg": "aa1e",
	"./game-logo_VirtualHorseRaces.svg": "7d2a",
	"./game-logo_VirtualMotorcycleSpeedway.svg": "4d15",
	"./game-logo_VirtualPenaltyShootout.svg": "43cc",
	"./game-logo_VirtualSoccer.svg": "a601"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "776d";